import { render } from "./SafetyVerification.vue?vue&type=template&id=3df0640e"
import script from "./SafetyVerification.vue?vue&type=script&lang=js"
export * from "./SafetyVerification.vue?vue&type=script&lang=js"

import "./SafetyVerification.vue?vue&type=style&index=0&id=3df0640e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__